import { createRouter, createWebHistory } from "vue-router";
import { routes } from "@/router/routes";
import store from "@/store";
import { getUserInfo } from "@/services/login";
import { gotoLogin } from "@/utils/auth";

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  const needAuth = to.matched.find((record: any) => record.meta.requiresAuth);
  const needToSetTitle = to.matched.find((record) => record.meta.title);
  const meta = to.meta || {};

  if (needToSetTitle) {
    document.title = needToSetTitle.meta.title as string;
  } else {
    document.title = "售后线索平台";
  }
  const token: any =
    to.query.token ||
    store.state.base.token ||
    localStorage.getItem("idmToken");
  // 做一些其他的事情
  if (needAuth) {
    if (!token) {
      // 登录后进入原本需要跳转的页面需带入参数
      let redirectUrl = "";
      const href = window.location.href;
      const hashIndex = href.indexOf("#");
      redirectUrl = `${href.slice(hashIndex + 1)}`;
      return next(`/login${redirectUrl ? "?redirectUrl=" + redirectUrl : ""}`);
    }
    if (!store.state.base.userInfo) {
      getUserInfo(token).then((res: any) => {
        if (res.resultCode === 200) {
          // console.log("userData ", res.data);
          store.commit("setToken", token as string);
          localStorage.setItem("idmToken", token as string);
          store.commit("setUserInfo", res.data);
          return next({ ...to, replace: true });
        } else if (res.resultCode === 5002) {
          gotoLogin();
        }
      });
    }
    next();
  } else {
    next();
  }
});

// ---afterRouter --- //
router.afterEach((to, from) => {
  const name = to.name as string;
  const meta = to.meta || {};
  const pageTypeName = meta.pageTypeName || "";

  // 做一些其他的事情
});

export default router;
